export default __webpack_public_path__ + "dd4f59b2c97642539b2eac05664b2b5a.png";